// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2V8Ks","top":"styles_top__LvlNc"};